import {
    Component,
    OnInit,
    ChangeDetectionStrategy,
    Input,
    ChangeDetectorRef,
    ViewChild,
    ElementRef,
    ViewChildren,
    QueryList,
    ViewEncapsulation,
    computed,
} from "@angular/core";
import { S25EventOccurrencesService } from "./s25.event.occurrences.service";
import { S25EventUtil } from "../utils/s25.event.util";
import { S25Util } from "../../../util/s25-util";
import { S25ReservationUtil } from "../utils/s25.reservation.util";
import { Debounce } from "../../../decorators/debounce.decorator";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { UserprefService } from "../../../services/userpref.service";
import { ObjectPermissionService } from "../../../services/object.permission.service";
import { S25TableComponent } from "../../s25-table/s25.table.component";
import { S25LoadingApi } from "../../s25-loading/loading.api";
import { S25EventOccurrencesListComponent } from "./s25.event.occurrences.list.component";
import { PopoverComponent } from "../../s25-popover/popover.component";
import { S25ItemI } from "../../../pojo/S25ItemI";
import { OptBean, S25OptComponent } from "../../s25-opt/s25.opt.component";
import { FlsService } from "../../../services/fls.service";
import { OccurrenceDateComponent } from "./s25-event-occurrence/occ-table-components/occurrence.date.component";
import { Bind } from "../../../decorators/bind.decorator";
import { S25ProfileUtil } from "../utils/s25.profile.util";
import { EvOccMenuOutput, EvOccMenuComponent } from "./ev-occ-menu/ev-occ-menu.component";
import { EventProfileMicroService, ProfileMinimalI } from "../../../services/event.profile.micro.service";
import { S25Reservation, ObjectType, S25RmReservation, S25RsReservation } from "../ReservationI";
import { S25Event } from "../EventMicroI";
import { RecordType, S25Profile } from "../ProfileI";
import { S25Datefilter } from "../../s25-dateformat/s25.datefilter.service";
import { Event } from "../../../pojo/Event";
import State = Event.State.Ids;
import Rsrv = Event.Reservation.States;
import { EventMicroService } from "../../../services/event.micro.service";
import { ModalService } from "../../modal/modal.service";
import { NotificationService } from "../../../services/notification.service";
import { TelemetryService } from "../../../services/telemetry.service";
import { OccurrenceAddedTimeComponent } from "./s25-event-occurrence/occ-table-components/occurrence.added.time.component";
import { S25EventColanderComponent } from "../s25-event-colander/s25-event-colander.component";

/**
 * Parent component for event occurrences view
 */
@TypeManagerDecorator("s25-ng-event-occurrences")
@Component({
    selector: "s25-ng-event-occurrences",
    template: `
        @if (optInit && occurrencesListOriginal.length > 0) {
            <s25-ng-opt [modelBean]="optBean" (editModeChange)="onEditToggle($event)"></s25-ng-opt>
        }

        @if (optInit && occurrencesListOriginal.length === 0) {
            <div class="textCenter">No occurrences are found.</div>
        }

        @if (init) {
            <div>
                @if (occurrencesListOriginal.length > 0) {
                    <div class="occ-adj-wrapper">
                        <div class="prefs-wrapper">
                            @for (profile of event?.profile; track profile.itemId; let i = $index) {
                                <s25-ng-ev-prefs
                                    [eventId]="eventId"
                                    [profileName]="profile.itemName"
                                    [profileId]="profile.itemId"
                                ></s25-ng-ev-prefs>
                            }

                            <!-- if just one location/resource no need to have filter -->

                            <ng-container>
                                @if (event && allLocations && allLocations.length > 1) {
                                    <s25-ng-ev-colander
                                        #locColander
                                        [type]="'location'"
                                        [data]="allLocations"
                                        [noLocations]="noLocations.length > 0"
                                        (modelValueChange)="onColenderChange($event, 'location')"
                                    ></s25-ng-ev-colander>
                                }

                                @if (event && allResources && allResources.length > 1) {
                                    <s25-ng-ev-colander
                                        #resColander
                                        [type]="'resource'"
                                        [data]="allResources"
                                        [noResources]="noResources.length > 0"
                                        (modelValueChange)="onColenderChange($event, 'resource')"
                                    ></s25-ng-ev-colander>
                                }
                            </ng-container>
                        </div>
                        <div class="s25ph-title ng-binding">
                            @if (!isSeparatedView || !multiProfiles) {
                                <div class="s25ph-title ng-binding">
                                    <span class="ngBold">Event Occurrences</span>
                                    <span class="dataView">
                                        (view as of
                                        {{
                                            occurrencesList.length > 2
                                                ? lastUpdate + ", " + occurrencesList.length + " occurrences"
                                                : lastUpdate
                                        }})
                                    </span>
                                </div>
                            }

                            @if (!isSeparatedView) {
                                <div class="occurrence-border">
                                    <s25-ng-occ-menu
                                        [isSeparatedView]="isSeparatedView"
                                        [canEdit]="editMode"
                                        [profileId]="event.profile[0].itemId"
                                        [multiProfiles]="multiProfiles"
                                        [startDate]="defaultStartDate"
                                        [endDate]="defaultEndDate"
                                        [eventId]="eventId"
                                        (modelValueChange)="onViewChange($event)"
                                    >
                                    </s25-ng-occ-menu>
                                </div>

                                <s25-ng-event-occurrences-list
                                    [occurrencesList]="occurrencesList"
                                    [canEdit]="canEdit"
                                    [editMode]="editMode"
                                    (refreshF)="refresh()"
                                    (dateTimeChangedF)="dateTimeChanged($event)"
                                >
                                </s25-ng-event-occurrences-list>

                                @if (!multiProfiles) {
                                    <ng-container
                                        *ngTemplateOutlet="profileProperties; context: { profile: event.profile[0] }"
                                    ></ng-container>
                                }
                            } @else if (isSeparatedView) {
                                @for (p of event.profile; track p.itemId; let idx = $index) {
                                    <div class="segment-wrapper c-margin-bottom--double">
                                        @if (occurrencesListGroupBy[p.itemId]) {
                                            <div class="occurrence-border">
                                                <s25-ng-occ-menu
                                                    [isSeparatedView]="isSeparatedView"
                                                    [canEdit]="editMode"
                                                    [profileId]="p?.itemId"
                                                    [multiProfiles]="multiProfiles"
                                                    [startDate]="defaultStartDate"
                                                    [endDate]="defaultEndDate"
                                                    [isFirstSegment]="idx === 0"
                                                    (modelValueChange)="onViewChange($event)"
                                                >
                                                </s25-ng-occ-menu>
                                            </div>
                                            <div class="segmentName ngBold">
                                                <s25-ng-editable-text
                                                    class="segmentName"
                                                    [allowEmpty]="false"
                                                    [val]="p.itemName"
                                                    [min]="2"
                                                    [max]="40"
                                                    [readOnly]="!editMode"
                                                    hasCommit="true"
                                                    hasCancelButton="true"
                                                    hasCommitButton="true"
                                                    commitButtonText="Save"
                                                    cancelButtonText="Cancel"
                                                    (valChange)="onProfileNameChange(p.itemId, p.itemName, $event)"
                                                ></s25-ng-editable-text>
                                            </div>

                                            <s25-ng-event-occurrences-list
                                                [occurrencesList]="occurrencesListGroupBy[p.itemId]"
                                                [editMode]="editMode"
                                                [canEdit]="canEdit"
                                                [isSeparatedView]="isSeparatedView"
                                                (refreshF)="refresh()"
                                                (dateTimeChangedF)="dateTimeChanged($event)"
                                            >
                                            </s25-ng-event-occurrences-list>
                                        }
                                        <ng-container
                                            *ngTemplateOutlet="profileProperties; context: { profile: p }"
                                        ></ng-container>
                                    </div>
                                }
                            }
                        </div>
                    </div>
                }
            </div>
        }

        <ng-template #profileProperties let-profile="profile">
            @if (event && !showCommentAndAdditionalTimes && !showLoading && editMode) {
                @if (canEditComment) {
                    <div class="comments c-margin-top--single c-margin-bottom--single">
                        <label>
                            <!--Segment comments are also visible on event details page-->
                            <label class="ngBold c-margin-bottom--quarter" for="segment-comments-{{ profile.itemId }}"
                                >Segment Comments:</label
                            >
                            <s25-ng-editable-textarea
                                [(val)]="profile.comment"
                                [readOnly]="!canEdit && !canEditComment"
                                [fieldId]="'segment-comments-' + profile.itemId"
                                placeholder="Add comments"
                                hasCommit="true"
                                hasCancelButton="true"
                                hasCommitButton="true"
                                commitButtonText="Save"
                                cancelButtonText="Cancel"
                                (valChange)="onCommentChange(profile.itemId, $event)"
                            >
                            </s25-ng-editable-textarea>
                        </label>
                    </div>
                }

                <div class="additional-time">
                    <s25-ng-occurrence-added-time
                        [profileId]="profile.itemId"
                        [readOnly]="!canEdit"
                        (refreshF)="onAddedTimeChanges($event)"
                    ></s25-ng-occurrence-added-time>
                </div>
            }
        </ng-template>
    `,
    styles: `
        .textCenter {
            text-align: center;
        }

        .segment-wrapper {
            box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 8px;
            padding-block: 1rem;
            border-radius: 3px;
        }

        ::ng-deep .segment-wrapper > * {
            padding-inline: 1rem;
        }

        ::ng-deep .segment-wrapper s25-ng-event-occurrences-list {
            display: block;
        }

        ::ng-deep .segment-wrapper .occ-list-wrapper {
            margin-inline: -1rem;
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class S25EventOccurrencesComponent implements OnInit {
    @ViewChild(S25TableComponent) tableComponent: S25TableComponent;
    @ViewChild(OccurrenceDateComponent) occDateComponent: OccurrenceDateComponent;
    @ViewChild(S25EventOccurrencesListComponent) occTable: S25EventOccurrencesListComponent;
    @ViewChildren("occurrence") occurrenceElements: QueryList<ElementRef>;
    @ViewChild(PopoverComponent) popoverChild: PopoverComponent;
    @ViewChild(S25OptComponent) optComponent: S25OptComponent;
    @ViewChild(EvOccMenuComponent) menuComponent: EvOccMenuComponent;
    @ViewChild(OccurrenceAddedTimeComponent) occAddedTimeComponent: OccurrenceAddedTimeComponent;
    @ViewChild("locColander") locColander: S25EventColanderComponent;
    @ViewChild("resColander") resColander: S25EventColanderComponent;

    @Input() eventId: number;

    event: S25Event;
    count: number = 0;
    occurrencesList: S25Reservation[];
    occurrencesListOriginal: S25Reservation[];
    init = false;
    isExpandAll?: boolean = false;
    optInit = false;
    dateFormat: string;
    timeFormat: string;
    canEdit: boolean = false;
    editMode: boolean;
    optBean: OptBean = {
        autoInit: false,
        refreshF: this.refresh.bind(this),
        hasOpt: true,
        hasEventStateChange: true,
        hasRefresh: true,
        hasEditEvent: true,
        hasSecurity: true,
        hasEditToggle: true,
        hasHelp: true,
        helpTopic: "view_eventsingle_detail",
        hasTimestamp: true,
        occurrenceDetails: true,
    };
    multiProfiles: boolean = false;
    locationFilter: Filter = { filterType: "any", itemList: [] as any[] };
    resourceFilter: Filter = { filterType: "any", itemList: [] as any[] };
    isSeparatedView: boolean = false;
    occurrencesListGroupBy: any = [];
    lastUpdate: Date | string | number = S25Util.date.toS25ISODateTimeStr(new Date());
    showCommentAndAdditionalTimes: boolean = true;
    defaultStartDate: Date = new Date();
    defaultEndDate: Date = new Date();
    showLoading: boolean = false;
    canEditComment: boolean = false;
    allLocations: S25ItemI[];
    allResources: S25ItemI[];
    noLocations: S25Reservation[] = [];
    noResources: S25Reservation[] = [];

    constructor(
        private occurrencesService: S25EventOccurrencesService,
        private cd: ChangeDetectorRef,
        private elementRef: ElementRef,
    ) {}

    /**
     * Inits the component, the opt bean calls getData() so no need to do that ourselves.
     */
    async ngOnInit() {
        S25LoadingApi.init(this.elementRef.nativeElement);
        //Get preferences and security. Event data will be fetched by the opt bar
        await Promise.all([this.getPreferences(), this.getSecurity()]);
        this.configureOptBean();
        await this.getData();
        this.lastUpdate = S25Datefilter.transform(S25Util.date.toS25ISODateTimeStr(new Date()), this.timeFormat);
        this.optInit = true;
        S25LoadingApi.destroy(this.elementRef.nativeElement);
        this.cd.detectChanges();
    }

    configureOptBean() {
        this.optBean.itemId = this.eventId;
        this.optBean.itemTypeId = 1;
        this.optBean.canEdit = this.canEdit;
        this.cd.detectChanges();
    }

    async getPreferences() {
        const [dateFormat, timeFormat] = await Promise.all([
            UserprefService.getS25Dateformat(),
            UserprefService.getS25Timeformat(),
        ]);
        this.dateFormat = dateFormat;
        this.timeFormat = timeFormat;
        return;
    }

    async getSecurity() {
        const [canEdit, fls] = await Promise.all([
            ObjectPermissionService.canEditCurrentState(this.eventId),
            FlsService.getFls(),
        ]);
        this.canEdit = canEdit && fls.EVENT_OCC_DIRECT == "F";
        this.canEditComment = fls.EVENT_TEXT === "F";
        return;
    }

    @Bind
    async getData(force?: boolean) {
        let [event, error] = await S25Util.Maybe(this.occurrencesService.getEvent(this.eventId, force));

        if (error) console.error(error);
        this.event = event;
        this.event.profile = event.profile.sort((a: S25Profile, b: S25Profile) => {
            return new Date(a.occurrenceDefn.initStartDt).getTime() - new Date(b.occurrenceDefn.initStartDt).getTime();
        });

        let occurrencesListComput = computed(() => {
            return this.occurrencesService.getOccurrences();
        });
        this.occurrencesList = occurrencesListComput();
        this.occurrencesListOriginal = S25Util.array.clone(occurrencesListComput());

        this.defaultStartDate = S25Util.deepCopy(this.occurrencesList[0]?.eventStart);
        this.defaultEndDate = S25Util.deepCopy(this.occurrencesList[0]?.eventEnd);

        if (this.event.profile.length > 1) this.multiProfiles = true;
        if (!this.multiProfiles) this.isSeparatedView = true;
        if (this.isSeparatedView) this.groupByProfile();
        if (this.event.state !== State.Cancelled && this.event.state !== State.Denied)
            this.showCommentAndAdditionalTimes = false;
        if (!this.optBean.canEdit) this.init = true; // user has read event only set init here
        this.getAllObjs();
        return;
    }

    @Debounce(300) // Avoid double calls
    async refresh() {
        //only force new data if component is already initialized that is true refresh vs triggered from initial load
        const forceRefresh = this.init;
        this.init = false;
        this.cd.detectChanges();
        this.lastUpdate = S25Datefilter.transform(S25Util.date.toS25ISODateTimeStr(new Date()), this.timeFormat);
        await this.getData(forceRefresh);
        this.init = true;
        this.cd.detectChanges();
    }

    async onCommentChange(profileId: number, newVal: any) {
        // update profile  comment
        let data: ProfileMinimalI = { comments: newVal };
        try {
            const ok = await EventProfileMicroService.updateProfileMinimal(this.eventId, profileId, data);
        } catch (e) {
            S25Util.showError(e);
        }
    }

    async addToAll(minutes: number) {
        S25EventUtil.getAllOccurrences(this.event).forEach((occ) => {
            occ.eventStart = S25Util.date.addMinutes(occ.eventStart, minutes);
            occ.eventEnd = S25Util.date.addMinutes(occ.eventEnd, minutes);
        });
        this.cd.detectChanges();
    }

    async addOccurrence(newRsrv?: S25Reservation) {
        if (!newRsrv) {
            const rsrv = await S25ReservationUtil.createReservation(
                S25Util.date.parse("2023-12-2T15:02"),
                S25Util.date.parse("2023-12-2T16:05"),
            );
            S25EventUtil.addOccurrence(rsrv, this.event.profile[0]);
        } else {
            S25EventUtil.addOccurrence(newRsrv, this.event.profile[0]);
        }
        this.cd.detectChanges();
    }

    showAll(e: boolean) {
        this.isExpandAll = !this.isExpandAll;
        const elements: any = document.querySelectorAll(".occurrence-date-wrapper");
        for (let i = 0; i < elements.length; ++i) {
            elements[i].click();
        }
    }

    onEditToggle(e: boolean) {
        this.editMode = e;
        if (this.occTable) {
            //opt bar fetches preference value and emits editModeChange before occTable is initialized
            this.occTable.editMode = e;
            this.init && this.occTable.refresh();
        }
    }

    async onColenderChange(filterCriteria: Filter, type: ObjectType) {
        type === "location" ? (this.locationFilter = filterCriteria) : (this.resourceFilter = filterCriteria);
        const hasLocationFilters = this.locationFilter.itemList.length > 0;
        const hasResourceFilters = this.resourceFilter.itemList.length > 0;

        const hasNoLocation = this.locationFilter.itemList.includes("No Location");
        const hasNoResource = this.resourceFilter.itemList.includes("No Resource");
        const isLocationAny = this.locationFilter.filterType === "any";
        const isResourceAny = this.resourceFilter.filterType === "any";
        const shouldApplyNoObjFilter = hasNoLocation || hasNoResource;

        if (!hasLocationFilters && !hasResourceFilters) {
            this.occurrencesList = [];
        } else {
            let filteredList = this.occurrencesListOriginal;
            if (hasLocationFilters)
                filteredList = this.filterItemsByName(this.locationFilter, filteredList, "location");
            if (hasResourceFilters)
                filteredList = this.filterItemsByName(this.resourceFilter, filteredList, "resource");

            if (shouldApplyNoObjFilter) {
                if (isLocationAny || isResourceAny) {
                    await this.noObjFilter(this.occurrencesListOriginal, type);
                    if (hasNoLocation) filteredList = S25Util.array.uniqueDeep(filteredList.concat(this.noLocations));
                    if (hasNoResource) filteredList = S25Util.array.uniqueDeep(filteredList.concat(this.noResources));
                } else {
                    filteredList = await this.noObjFilter(filteredList, type);
                }
            }

            this.occurrencesList = S25Util.array.uniqueDeep(filteredList);
        }

        if (this.isSeparatedView) this.groupByProfile();
        if (this.occTable) this.occTable.refresh(this.occurrencesList ?? []);
        this.cd.detectChanges();
    }

    filterItemsByName(filterCriteria: Filter, filterData: S25Reservation[], type: ObjectType): S25Reservation[] {
        if (this.locationFilter.filterType === "any" || this.resourceFilter.filterType === "any") {
            const res = this.filterItemsByNameAny(filterData, "resource");
            const loc = this.filterItemsByNameAny(filterData, "location");
            return S25Util.array.uniqueDeep(res.concat(loc));
        } else {
            return this.filterItemsByNameAll(filterData, type);
        }
    }

    filterItemsByNameAll(filterData: S25Reservation[], type: ObjectType): S25Reservation[] {
        const sourceFilter = this.getFilterList(type);
        return filterData.filter((occ) => {
            const allItemNames = this.collectAllItemNames(occ, type);
            return sourceFilter.every((filterItemName) => allItemNames.has(filterItemName));
        });
    }

    filterItemsByNameAny(filterData: S25Reservation[], type: ObjectType): S25Reservation[] {
        const sourceFilter = this.getFilterList(type);
        return filterData.filter((occ) => {
            const sourceList = this.getSourceList(occ, type);
            return sourceList.some((sourceItem) =>
                ["draft", "requested", "reserved"].some((status) =>
                    sourceItem[status].some((item: S25ItemI) => sourceFilter.includes(item.itemName)),
                ),
            );
        });
    }

    getSourceList(occ: S25Reservation, type: ObjectType): S25ItemI[] {
        return type === "location" ? occ.locations : occ.resources;
    }

    getFilterList(type: ObjectType): string[] {
        return type === "location" ? this.locationFilter.itemList : this.resourceFilter.itemList;
    }

    collectAllItemNames(occ: S25Reservation, type: ObjectType): Set<string> {
        const sourceList = this.getSourceList(occ, type);
        const allItemNames = new Set<string>();
        sourceList.forEach((sourceItem) => {
            ["draft", "requested", "reserved"].forEach((status) => {
                sourceItem[status].forEach((item: S25ItemI) => allItemNames.add(item.itemName));
            });
        });
        return allItemNames;
    }

    async onViewChange(e: EvOccMenuOutput) {
        this.isSeparatedView = e.isSeparatedView;
        const sourceProfileId = e.data.sourceProfileId ?? null;
        if (e.addNew) await this.addProfile(e);

        if (this.isSeparatedView) this.groupByProfile();

        if (e.isDelete) await this.deleteProfile(e.data.profileId);

        this.cd.detectChanges();
    }

    groupByProfile() {
        this.occurrencesList.forEach((item) => {
            item.rowAction = "create";
        });
        this.occurrencesListGroupBy = S25Util.array.groupBy(this.occurrencesList, (item) => item.profileId);
    }

    @Debounce(300) // Avoid double calls
    async addProfile(outputData: EvOccMenuOutput) {
        let trackSegmentType = "AddSegment";
        let newProfile: S25Profile;
        const data2 = outputData.data;
        if (!data2.isCopySegment) {
            newProfile = data2.newProfile;
        } else {
            //grab the profile of the sourceProfileId   copy segment
            const sourceProfile = this.event.profile.find((p) => p.itemId === data2.sourceProfileId);
            newProfile = await S25ProfileUtil.duplicateProfile(sourceProfile, outputData);

            // if RecurrenceGrammar = 1
            if (newProfile.occurrenceDefn.recTypeId === RecordType.RecurrenceGrammar) {
                if (data2.newProfileCode !== "") {
                    newProfile.occurrenceDefn.profileCode = data2.newProfileCode;
                } else {
                    newProfile.occurrenceDefn.profileCode = "";
                    newProfile.occurrenceDefn.recTypeId = RecordType.FreeForm;
                }
            }

            trackSegmentType = "CopySegment";
        }

        this.occurrencesService.addProfile(newProfile);

        let normalizeData = await S25ProfileUtil.normalizeProfileWSData(
            this.event,
            S25Util.array.forceArray(newProfile),
        );
        let data = normalizeData[0].data;

        this.setLoading(true);
        TelemetryService.sendWithSub("EventDetails", "EventDetailsOcc", trackSegmentType);
        const [ok, error] = await S25Util.Maybe(EventMicroService.microPutEventDetail(data, this.eventId));
        if (ok) {
            if (ok?.content?.errors || ok?.content?.messages) {
                for (let error of ok?.content?.errors || ok?.content?.messages) {
                    NotificationService.post(error.message);
                }
            }
            this.occurrencesService.getEvent(this.eventId, false, ok); //fetch newUpateData
            await this.getData(false);
            this.multiProfiles = true;
            this.isSeparatedView = true;
            this.cd.detectChanges();
        }
        if (error) return S25Util.showError(error, "There was an error while attempting to copy this reservation.");
        this.setLoading(false);
    }

    async onProfileNameChange(profileId?: number, initVal?: string, newVal?: string) {
        let data: ProfileMinimalI = { name: newVal };
        if (initVal && newVal && initVal !== newVal)
            // update profile name
            try {
                const ok = await EventProfileMicroService.updateProfileMinimal(this.eventId, profileId, data);
            } catch (e) {
                S25Util.showError(e);
            }
    }

    @Debounce(300) // Avoid double calls
    async deleteProfile(sourceProfileId?: number) {
        let dialogData = ModalService.dialogType(
            "Yes No",
            {
                message: "Are you sure you want to delete this segment?",
                title: "Confirm Deletion",
            },
            "No",
        );
        await ModalService.modal("dialog", dialogData);
        if (dialogData.answer !== 1) return; // User answered no

        // keep the codes for event micor service support remove profile Id
        /*
        let payload: EventDataMicroI = {
            items: [
                {
                    kind: "event",
                    id: this.eventId,
                    profiles: [
                        {
                            profileId: sourceProfileId,
                            remove: {
                                profileId: sourceProfileId,
                            },
                        },
                    ],
                },
            ],
        };
        const [ok, error] = await S25Util.Maybe(EventMicroService.microPutEventDetail(payload, this.eventId));
        */
        TelemetryService.sendWithSub("EventDetails", "EventDetailsOcc", "DeleteSegment");
        const [ok, error] = await S25Util.Maybe(EventProfileMicroService.deleteProfile(this.eventId, sourceProfileId));
        if (ok) {
            this.event.profile = this.event.profile.filter((profile) => profile.itemId !== sourceProfileId);
            this.event.profile.length > 1 ? (this.multiProfiles = true) : (this.multiProfiles = false);
            this.occurrencesList = this.occurrencesService.getOccurrences();
            this.cd.detectChanges();
        }
        if (error) return S25Util.showError(error, "There was an error while attempting to delete this segment.");
    }

    setLoading(yes: boolean) {
        this.showLoading = yes;
        if (yes) {
            S25LoadingApi.init(this.elementRef.nativeElement);
        } else {
            S25LoadingApi.destroy(this.elementRef.nativeElement);
        }
        this.cd.detectChanges();
    }

    async getAllObjs(): Promise<void> {
        const allLocations: S25RmReservation[] = [];
        const allResources: S25RmReservation[] = [];
        const activeOccs = this.occurrencesListOriginal.filter(
            (occ) => occ.state !== Rsrv.Cancelled && occ.state !== Rsrv.Exception,
        );
        for (const occ of activeOccs) {
            if (occ.locations?.length > 0) {
                const locationObjs = S25ReservationUtil.getObjectsFlat(occ.locations[0]);
                allLocations.push(...locationObjs);
            } else {
                this.noLocations.push(occ);
            }
            if (occ.resources?.length > 0) {
                const resourceObjs = S25ReservationUtil.getObjectsFlat(occ.resources[0]);
                allResources.push(...resourceObjs);
            } else {
                this.noResources.push(occ);
            }
        }
        this.allLocations = S25Util.array.unique(allLocations);
        this.allResources = S25Util.array.unique(allResources);
        this.locationFilter.itemList = this.getSortedItemList(this.allLocations, "No Location", this.noLocations);
        this.resourceFilter.itemList = this.getSortedItemList(this.allResources, "No Resource", this.noResources);
        this.locColander?.init && this.locColander.refresh(this.locationFilter.itemList);
        this.resColander?.init && this.resColander.refresh(this.resourceFilter.itemList);
    }

    getSortedItemList(items: any[], noItemLabel: string, emptySource: any[]): string[] {
        const itemNames = [...new Set(items.map((item) => item.itemName))].sort();
        if (emptySource?.length > 0) itemNames.unshift(noItemLabel);
        return itemNames;
    }

    async onAddedTimeChanges(profileId: number) {
        this.lastUpdate = S25Datefilter.transform(S25Util.date.toS25ISODateTimeStr(new Date()), this.timeFormat)!;
        await this.getData(false);
        if (this.multiProfiles) this.isSeparatedView = true;
        const occList = this.occurrencesList.filter((occ) => occ.profileId === profileId);
        this.occTable.refresh(occList);
        this.cd.detectChanges();
    }

    async dateTimeChanged(itemId: number) {
        await this.getData(false);
        this.occAddedTimeComponent?.refresh();
        this.occurrencesList.forEach((item) => {
            if (item.itemId === itemId) {
                item.rowAction = "delete";
            }
        });
    }

    async noObjFilter(occs: S25Reservation[], type: ObjectType) {
        if (this.locationFilter.filterType === "all" && this.resourceFilter.filterType === "all") {
            occs = occs.concat(this.noLocations).concat(this.noResources);
        } else {
            if (type === "location") occs = occs.concat(this.noLocations);
            if (type === "resource") occs = occs.concat(this.noResources);
        }
        return S25Util.array.uniqueDeep(occs);
    }
}

export type Filter = { filterType: "any" | "all"; itemList: string[] };
